/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// react-countup component
import CountUp from "react-countup";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function DefaultCounterCard({ color, count, title, description, ...rest }) {
  return (
    <MKBox
      className="school-stat"
      p={{ xs: 3, md: 4 }}
      textAlign="center"
      lineHeight={1}
      height="100%"
      minHeight={{ xs: 210, md: 230 }}
      width="100%"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={({ palette: { white, primary }, functions: { rgba } }) => ({
        borderRadius: "28px",
        border: "1px solid rgba(255,255,255,0.72)",
        background: `linear-gradient(145deg, ${rgba(white.main, 0.88)}, ${rgba("#fff3df", 0.72)})`,
        boxShadow: "0 20px 52px rgba(24, 34, 54, 0.08)",
        position: "relative",
        overflow: "hidden",
        "&::before": {
          content: '""',
          position: "absolute",
          inset: "auto 18% 0",
          height: 3,
          borderRadius: "999px",
          background: `linear-gradient(90deg, transparent, ${rgba(
            primary.main,
            0.65
          )}, transparent)`,
        },
      })}
    >
      <MKTypography
        variant="h1"
        color={color}
        textGradient
        sx={{ fontSize: { xs: "3rem", md: "4rem" }, lineHeight: 0.95 }}
      >
        <CountUp end={count} duration={1} {...rest} />
      </MKTypography>
      {title && (
        <MKTypography variant="h5" mt={2} mb={1}>
          {title}
        </MKTypography>
      )}
      {description && (
        <MKTypography variant="body2" color="text">
          {description}
        </MKTypography>
      )}
    </MKBox>
  );
}

// Setting default props for the DefaultCounterCard
DefaultCounterCard.defaultProps = {
  color: "info",
  description: "",
  title: "",
};

// Typechecking props for the DefaultCounterCard
DefaultCounterCard.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  count: PropTypes.number.isRequired,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default DefaultCounterCard;
